export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14070.726e74f0.jpg";